import InViewLazyComponent from '@v4/common/components/atoms/InViewLazyComponent/InViewLazyComponent';

export default InViewLazyComponent;
